import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import { triggerSilentRedirect } from './AuthContext';
import { hasUrlAccessToken } from './config';
import { useAuth } from './useAuth';

export const AuthGuard: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth();

  useEffect(() => {
    if (!isAuthenticated && !isLoading && !hasUrlAccessToken()) {
      // Attempt a silent Cognito round-trip (prompt=none).
      // If the SSO session is alive the user returns with a fresh code
      // and never sees the login page. If expired, the callback redirects to /login.
      triggerSilentRedirect();
    }
  }, [isAuthenticated, isLoading]);

  if (hasUrlAccessToken()) {
    return <Outlet />;
  }

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return null;
  }

  return <Outlet />;
};
